import { LRLanguage } from '@codemirror/language';
import { EditorState } from '@codemirror/state';
import { EditorView } from '@codemirror/view';
import { parser } from '@/prometheus/lezer';

const lightPromQLSyntax = LRLanguage.define({ parser: parser });

function createPromQLEditorState(expr: string): EditorState {
  return EditorState.create({
    doc: expr,
    extensions: lightPromQLSyntax,
  });
}

function createEditorView(state: EditorState) {
  return new EditorView({ state, parent: document.createElement('div') });
}

export function createPromQLEditorView(expr: string) {
  const state = createPromQLEditorState(expr);
  return createEditorView(state);
}
